var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7375 17.6625H18C18.35 17.6625 18.6437 17.5375 18.8812 17.2875C19.1187 17.0375 19.2375 16.7375 19.2375 16.3875V12.9L22.5 16.1625V7.65L19.2375 10.9125V7.3875C19.2375 7.0375 19.1187 6.74375 18.8812 6.50625C18.6437 6.26875 18.35 6.15 18 6.15H8.7375C8.3875 6.15 8.09375 6.26875 7.85625 6.50625C7.61875 6.74375 7.5 7.0375 7.5 7.3875V16.3875C7.5 16.7375 7.61875 17.0375 7.85625 17.2875C8.09375 17.5375 8.3875 17.6625 8.7375 17.6625ZM0 30V2.25C0 1.675 0.225 1.15625 0.675 0.69375C1.125 0.23125 1.65 0 2.25 0H27.75C28.325 0 28.8438 0.23125 29.3063 0.69375C29.7688 1.15625 30 1.675 30 2.25V21.75C30 22.325 29.7688 22.8438 29.3063 23.3063C28.8438 23.7688 28.325 24 27.75 24H6L0 30ZM2.25 24.5625L5.0625 21.75H27.75V2.25H2.25V24.5625ZM2.25 2.25V21.75V24.5625V2.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.83dd03e9e93fc8ff0ee2d11716101f7b.svg";
export { ForwardRef as ReactComponent };